import { connect } from 'react-redux'

import { personsBeneficialOwnersChanged } from './actions'

const mapStateToProps = (state, hocProps) => ({
    data: state.getIn([
        'ui',
        'workspace',
        'report',
        hocProps?.id,
        'blocks',
        'persons',
        'customData',
        'beneficialOwners',
        'data',
    ]),
    isLoading: state.getIn([
        'ui',
        'workspace',
        'report',
        hocProps?.id,
        'blocks',
        'persons',
        'customData',
        'beneficialOwners',
        'isLoading',
    ]),
    pagination: state.getIn([
        'ui',
        'workspace',
        'report',
        hocProps?.id,
        'blocks',
        'persons',
        'customData',
        'beneficialOwners',
        'pagination',
    ]),
    sorted: state.getIn([
        'ui',
        'workspace',
        'report',
        hocProps?.id,
        'blocks',
        'persons',
        'customData',
        'beneficialOwners',
        'sorted',
    ]),
    filter: state.getIn([
        'ui',
        'workspace',
        'report',
        hocProps?.id,
        'blocks',
        'persons',
        'customData',
        'beneficialOwners',
        'filter',
    ]),
})

export default connect(mapStateToProps, { personsBeneficialOwnersChanged })
